var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCarroVacio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6092 120C39.2706 120 33.333 126 33.333 133.333C33.333 140.667 39.2706 146.667 46.6092 146.667C53.9477 146.667 59.952 140.667 59.952 133.333C59.952 126 53.9477 120 46.6092 120ZM113.323 120C105.985 120 100.047 126 100.047 133.333C100.047 140.667 105.985 146.667 113.323 146.667C120.662 146.667 126.666 140.667 126.666 133.333C126.666 126 120.662 120 113.323 120Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3328 133.333C53.3328 137.015 50.3481 140 46.6662 140C42.9843 140 39.9995 137.015 39.9995 133.333C39.9995 129.652 42.9843 126.667 46.6662 126.667C50.3481 126.667 53.3328 129.652 53.3328 133.333Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 133.333C120 137.015 117.015 140 113.333 140C109.651 140 106.666 137.015 106.666 133.333C106.666 129.652 109.651 126.667 113.333 126.667C117.015 126.667 120 129.652 120 133.333Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7998 98.3332L47.9998 97.5332L53.9998 86.6666H103.667C108.667 86.6666 113.066 83.9333 115.333 79.7999L141.066 33.0666L129.466 26.6666H129.4L122.066 39.9999L103.667 73.3332H56.8665L55.9998 71.5332L41.0665 39.9999L34.7332 26.6666L28.4665 13.3333H6.6665V26.6666H19.9998L43.9998 77.2666L34.9998 93.5999C33.9332 95.4666 33.3332 97.6666 33.3332 99.9999C33.3332 107.333 39.3332 113.333 46.6665 113.333H126.667V99.9999H49.4665C48.5998 99.9999 47.7998 99.2666 47.7998 98.3332Z",
    fill: "#FFD600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 33.3333L96.475 29.8083L82.5 43.7583V13.3333H77.5V43.7583L63.525 29.8083L60 33.3333L80 53.3333L100 33.3333Z",
    fill: "#17CF63"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCarroVacio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CarroVacio.1ce6b867.svg";
export { ForwardRef as ReactComponent };